import cyrillePhoto from '@/assets/cyrille-lecourt.webp';

const AuthorCard = () => (
  <div className="flex items-start gap-5 p-6 rounded-xl border border-border bg-card">
    <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-border shrink-0">
      <img src={cyrillePhoto} alt="Cyrille Lecourt" className="w-full h-full object-cover object-top" />
    </div>
    <div className="flex-1 min-w-0">
      <p className="font-heading font-bold text-foreground text-sm">Cyrille Lecourt</p>
      <p className="text-xs text-muted-foreground mt-0.5">Fondateur — Cygnature Production</p>
      <p className="text-xs text-muted-foreground mt-2 leading-relaxed">
        Wedding Planner, Officiant, Producteur de talents et organisateur d'événements. 25 ans d'expérience au service de vos moments les plus précieux.
      </p>
    </div>
  </div>
);

export default AuthorCard;
